import { signal } from '@preact/signals-react'

export const idNameBatch = signal({})
export const batchTableCellData = signal({})
export const batchIdStatusList = signal([])
export const batchListData = signal([])

export const setBatchData = (newData) => {
    const allBatches = [...batchListData.value]
    const targetIdx = allBatches.findIndex(item => item.id_batch === newData?.id_batch)

    if (targetIdx !== -1) {
        allBatches[targetIdx] = { ...allBatches[targetIdx], ...newData }
    } else {
        allBatches.unshift(newData)
    }
    batchListData.value = allBatches
    batchTableCellData.value = {
        ...batchTableCellData.value,
        [newData.id_batch]: {
            ...batchTableCellData.value[newData.id_batch] || {},
            ...newData,
        }
    }
}